import Cookies from 'js-cookie';
import { atomWithStorage } from 'jotai/utils';

export const AVOID_CDN_COOKIE_NAME = 'uppbeat_avoid_cdn';

/**
 * Cookie storage that coerces the string value from js-cookie to a number.
 * Only 0 and 1 are valid values; anything else falls back to 0.
 */
const avoidCdnCookieStorage = {
  getItem: (key: string): number => {
    const raw = Cookies.get(key);
    if (raw === undefined) {
      return 0;
    }
    const num = Number(raw);
    return num === 0 || num === 1 ? num : 0;
  },
  setItem: (key: string, newValue: number): void => {
    if (newValue === 0 || newValue === 1) {
      Cookies.set(key, String(newValue), {
        path: '/',
        sameSite: 'strict',
        expires: 365,
      });
    }
  },
  removeItem: (key: string): void => {
    Cookies.remove(key, { path: '/' });
  },
};

/**
 * Controls whether API requests bypass the CDN.
 * Stored in a dedicated cookie so it can be read server-side by `cdn.ts`.
 *
 * 0 = use CDN (default), 1 = bypass CDN.
 */
export const avoidCdnAtom = atomWithStorage<number>(
  AVOID_CDN_COOKIE_NAME,
  0,
  avoidCdnCookieStorage
);

avoidCdnAtom.debugLabel = 'avoidCdnAtom';
